<template>
    <el-dialog
        :visible.sync="show"
        width="800px"
        title="支付"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        append-to-body
        custom-class="pay-dialog"
        :before-close="handleClose"
    >
        <iframe v-if="url" :src="url" frameborder="0"></iframe>
    </el-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
import {getAutologinandredirectUrl, getRedirectUrl} from '@/util/util';

export default {
    name: 'PayDialogIframe',
    props: {
        price: {
            type: String,
            default: ''
        },
        originalprice: {
            type: String,
            default: ''
        },
        materialguid: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: true,
            url: ''
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    mounted() {
        this.createMaterialOrder();
        window.addEventListener('message', this.handleIframeMessage);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleIframeMessage);
    },
    methods: {
        createMaterialOrder() {
            this.$Api
                .createMaterialOrder({
                    materialguid: this.materialguid,
                    price: this.price,
                    originalprice: this.originalprice,
                    userguid: this.userInfo.userguid,
                    paymentcallercode: 'BQ-Anhui'
                })
                .then((data) => {
                    let orderguid = data.orderguid;

                    let redirecturl = getRedirectUrl(window.Config.payDialogUrl, {
                        orderguid,
                        productguid: orderguid
                    });

                    this.url = getAutologinandredirectUrl({
                        userguid: this.userInfo.userguid,
                        redirecturl
                    });
                    // let params = getRequestParams({
                    //     userguid: this.userInfo.userguid,
                    //     redirecturl
                    // });
                    // params.redirecturl = encodeURIComponent(redirecturl);
                    // for (let key in params) {
                    //     url += key + '=' + params[key] + '&';
                    // }
                    // this.url = url;
                });
        },
        handleClose() {
            this.$emit('close');
        },
        handleIframeMessage(event) {
            if (event.data.type === 'CLOSE_PAY_DIALOG') {
                this.handleClose();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep {
    .pay-dialog {
        height: 540px;

        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            padding: 0;

            iframe {
                width: 100%;
                height: 100%;
                border: none;
            }
        }
    }
}
</style>
